var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-icon-container",class:_vm.size == 'small' ? 'small' : ''},[_c('img',{class:['file-icon-content',_vm.iconClass],attrs:{"src":require("@/assets/icons/PPT.svg")}}),_c('div',{staticClass:"file-type-name"},[_vm._v(" "+_vm._s(_vm.handlerHtmlName(_vm.type || _vm.getFileExtension(_vm.fileName)))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }